/**
 * FullscreenImageViewer Component
 * Displays an image in fullscreen modal view
 */
import React from 'react';
import Image from 'next/image';
import { X } from 'lucide-react';

interface FullscreenImageViewerProps {
  fullscreenImage: string | null;
  onClose: () => void;
}

export const FullscreenImageViewer: React.FC<FullscreenImageViewerProps> = ({
  fullscreenImage,
  onClose,
}) => {
  if (!fullscreenImage) return null;

  return (
    <div
      className="fixed inset-0 bg-white z-50 flex items-center justify-center p-4 animate-fadeIn"
      onClick={onClose}
    >
      <button
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors"
        onClick={onClose}
        aria-label="Close fullscreen view"
      >
        <X className="w-6 h-6" />
      </button>
      <div className="max-w-full max-h-full">
        <Image
          src={fullscreenImage}
          alt="Fullscreen image"
          width={1200}
          height={800}
          className="max-h-[90vh] w-auto object-contain"
          unoptimized={true}
        />
      </div>
    </div>
  );
};